<ng-template #cardContent>
  <div class="p-4 h-100 position-relative" [appStoryblok]="_editable">
    <img
      *ngIf="image?.filename"
      height="600"
      width="400"
      class="bg"
      [ngSrc]="image.filename || ''"
      [loaderParams]="{ aspect: 0.67 }"
      sizes="(max-width: 991px) 66vw, 25vw"
    />
    <div
      class="z-1 position-relative d-flex flex-column h-100"
      [ngClass]="[colour]"
    >
      <h2 class="h5 fw-600" *ngIf="name">{{ name }}</h2>
      <img
        class="mt-auto ms-auto"
        *ngIf="link?.url"
        width="36"
        height="36"
        [src]="
          colour.includes('white')
            ? '/assets/right-circle-white.svg'
            : '/assets/right-circle.svg'
        "
      />
    </div>
  </div>
</ng-template>

<ng-container *ngIf="link?.url; else noLink">
  <a [storyblokLink]="link">
    <ng-container *ngTemplateOutlet="cardContent"></ng-container>
  </a>
</ng-container>

<ng-template #noLink>
  <ng-container *ngTemplateOutlet="cardContent"></ng-container>
</ng-template>
